export default {
    "/": {
        "title": "Taoify - 跨境电商独立站建站平台 | 中国货，卖全球",
        "desc": "Taoify 把建站、翻译、上架、物流、收款、营销放进一个后台：18 位 AI 员工帮你干活，20 种语言开店，中国货卖到全世界。"
    },
    "/feature": {
        "title": "功能 · 开店要用的东西，这一页全有 · Taoify",
        "desc": "建站、翻译、上架、发货、收款、拉客户——Taoify 把跨境卖货需要的 15 个模块放在一个后台，不用再去外面拼七八个工具。"
    },
    "/ai-staff": {
        "title": "AI 员工 · 18 位 AI 员工，最忙的是拉流量那几位 · Taoify",
        "desc": "18 位 AI 员工里，增长组的 5 位专门解决「没人来」：12 项店铺体检、30 天营销方案、一件商品改写成 9 个渠道的成品、自动营销邮件把买过的人叫回来。"
    },
    "/logistics": {
        "title": "跨境物流 · 从你手里到客户手里 · Taoify",
        "desc": "头程、清关、干线、末端派送，三条线路按货物和时效选。云途、燕文、4PX 已接通，面单、轨迹、异常处理都在一个后台。"
    },
    "/payment": {
        "title": "收款与结算 · 客户怎么方便就怎么付 · Taoify",
        "desc": "PayPal、Stripe、信用卡、支付宝接上即用。外币收进来，人民币提出来，T+7 结算，费率和到账时间写在明面上。"
    },
    "/pricing": {
        "title": "价格 · 订阅套餐 + 阶梯佣金 · Taoify",
        "desc": "店铺按订阅套餐收费：基础版 $15/月、标准版 $29/月、旗舰版 $59/月，季付年付更省。交易佣金按月成交额阶梯，最低 3%。"
    },
    "/cases": {
        "title": "卖家案例 · 他们也在做同一件事 · Taoify",
        "desc": "义乌饰品、深圳 3C、广州服装，还有德国、美国、法国的卖家——六个人，六种起点，同一套做法。"
    },
    "/sign-up": {
        "title": "店铺开通 - Taoify 免费注册开店",
        "desc": "10 分钟搭建品牌独立站，零代码、订阅套餐全功能试用，全链路闭环。立即注册 Taoify，开启跨境电商之旅。"
    },
    "/for-china-sellers": {
        "title": "给中国卖家 · 你只管选品和定价，其余我们办 · Taoify",
        "desc": "建站、翻译、运费、打面单、答客户——跨境卖货中间这些麻烦事，平台替你做了。订阅套餐 + 阶梯佣金（低至 3%）。"
    },
    "/for-global-sellers": {
        "title": "给海外卖家：在中国的货架上选品，在你自己的店里卖 · Taoify",
        "desc": "不压货、不囤库存：从中国供应链选品上架，客户下单后由中国仓直发，你赚差价。BuyLink 还能把 1688、淘宝链接变成你的商品。"
    },
    "/template-index": {
        "title": "模版市场 - Taoify 专业网站主题模板",
        "desc": "适用于任何项目的专业主题网站模板，海量行业模板免费使用，根据需求自定义品牌形象和功能。"
    },
    "/question": {
        "title": "帮助中心 · 有问题，先在这里找 · Taoify",
        "desc": "开店、装修、上架、订单物流、收款、营销、账号权限——常见问题按分类整理，找不到再提工单。"
    },
    "/about-us": {
        "title": "关于 Taoify · 我们在做一件什么事",
        "desc": "Taoify 是给跨境卖家的一体化建站平台：建站、翻译、上架、物流、收款、营销在一个后台完成。"
    },
    "/privacy-policy": {
        "title": "隐私政策 · Taoify",
        "desc": "Taoify 如何收集、使用、存储和保护你的个人信息，以及你对自己的数据拥有的权利。"
    },
    "/terms-service": {
        "title": "服务条款 · Taoify",
        "desc": "使用 Taoify 平台服务的条款与条件：账号、店铺、订单、结算与责任划分。"
    },
    "/consumer-agreement": {
        "title": "退款政策 · Taoify",
        "desc": "Taoify 平台订单的退款与售后规则：申请条件、处理时限与到账方式。"
    },
    "/user-agreement": {
        "title": "用户协议 · Taoify",
        "desc": "注册和使用 Taoify 前请先阅读：账号注册、店铺经营规范与平台服务说明。"
    }
}
